import styled from 'styled-components';

const UpdateUserWrapper = styled.div`
  .search-user-input {
    border: none;
    border-bottom: 1px solid #333;
    outline: none;
    width: 100%;
    margin: 10px 0 20px 0;
  }
  .user-wrapper {
    align-items: center;
    width: 100%;
    .activate-edit-user {
      position: absolute;
      top: 13px;
      font-size: 20px;
      right: 20px;
      display: block;
      opacity: 0;
      pointer-events: none;
      transition: all 0.2s ease-out;
    }
    .toggle-user-text {
      margin: 0;
    }
    .user-name, .toggle-user-status, .update-user-role {
      margin: 0;
      width: 20%;
      align-self: center;
    }
    .user-email-id {
      margin: 0;
      width: 40%;
      align-self: center;
    }
    .toggle-user-btn {
      margin: 0 0 0 15px;
      width: auto;
      align-self: center;
    }
    .update-user-role .ant-select {
      margin: 0 0 0 20px;
    }
    .edit-enabled-options {
      align-items: center;
      .anticon {
        color: #2979ff;
        cursor: pointer;
        font-size: 18px;
        padding: 0 5px;
      }
    }
  }
  .header-user-wrapper {
    align-items: center;
    width: 100%;
    .user-name, .user-status, .user-role {
      width: 20%;
      margin: 0;
      font-size: 18px;
      color: #000;
    }
    .user-email-id {
      margin: 0;
      width: 40%;
      font-size: 18px;
      color: #000;
    }
  }
  .ant-list-item {
    position: relative;
    &:hover {
      color: #2979ff;
      background-color: #f0f8ff;
      .activate-edit-user {
        pointer-events: all;
        opacity: 1;
        color: #2979ff;
        cursor: pointer;
      }
    }
  }
`;

export default UpdateUserWrapper;


// WEBPACK FOOTER //
// ./src/components/Users/UpdateUser/UpdateUser.style.js